import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import useMutation from '#lib/hooks/use-mutation.js';
import { toast } from 'react-hot-toast';
import { isFunction } from '#lib/utils/function.js';

async function fetchFilters(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/filters`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

async function postPlaces(body) {
    const authHeaders = await getAuthHeader();
    const res = await fetchAndParse(`${API_URL}/p/place`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
    return res;
}

export function useFilters({ onError }) {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['filters'],
        queryFn: fetchFilters,
        staleTime: Infinity,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 0
    });

    const updatePlaces = useMutation({
        mutationKey: ['places'],
        mutationFn: async (model) => {
            await postPlaces(model);
        },
        onSuccess: () => {},
        onError: (e) => {
            isFunction(onError) && onError();
            toast.error(e.message);
        },
        invalidate: ['places'],
        enabled: false
    });

    return {
        totalFilters: data?.results,
        updatePlaces,
        ...queryProps
    };
}
